// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__39ftf","rootSuccess":"CompleteLink_rootSuccess__35KPV","rootFailure":"CompleteLink_rootFailure__1AZqA","isDisabled":"CompleteLink_isDisabled__2Yvnv"};